import { Tokens } from '@/assets/tokens'
import { Button } from '@/components'
import styled from 'styled-components'

export const SelectButton = styled(Button.Root)`
  background: transparent;
  border: none;
  text-decoration: none;

  color: ${Tokens.ColorUIPrimary};
  span {
    color: ${Tokens.ColorUIPrimary};
  }

  &:hover {
    text-decoration: none;
    background: transparent;
  }
`

export const CancelButton = styled(Button.Root)`
  background: transparent;
  border: none;
  text-decoration: none;

  color: ${Tokens.ColorUIDanger};
  span {
    color: ${Tokens.ColorUIDanger};
  }

  &:hover {
    text-decoration: none;
    background: transparent;
  }
`

export const CardsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 1.625rem;
`

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin: 1rem 0;
`
